import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio-checked",
  "use": "icon-radio-checked-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-radio-checked\"><path d=\"M512 0a512 512 0 1 0 0 1024A512 512 0 0 0 512 0z m0 896A384 384 0 1 1 512 128a384 384 0 0 1 0 768zM320 512a192 192 0 1 1 384 0 192 192 0 0 1-384 0z\" p-id=\"3546\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol